module.exports = __webpack_public_path__ + "static/media/la-ponderosa-360-preview.d7fa027f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/la-ponderosa-360-preview.jpg
// module id = 1156
// module chunks = 0